import SearchFilterBar from '../../components/ui/search-filter-bar'
import Pagination from '../../components/ui/pagination'
import { useExtensionProposal } from '../../hooks/proposal/use-extension-proposal'
import ProposalExtensionTBody from '../../components/module/request-extension/proposal-extension-tbody'
import SectionHeader from '../../components/ui/section-header'
import ProposalExtensionActionModal from '../../components/module/request-extension/modal/proposal-extension-action-modal'
import ProposalTHead from '../../components/ui/proposal-thead'
import { proposalHeaderData } from '../../constant/gms-constant'
import { useFilesActions } from '../../hooks/actions/use-files-actions'
import { useModalAccess } from '../../components/global/modal/use-modal-access'

export default function ExtensionRequestProposalPage() {

    const {
        getExtensionProposalRequest,
        loading,
        isErrorGetExtensionProposalRequest,
        normalizedOptions,
        errorMessage,
        searchType,
        setSearchType,
        searchValue,
        setSearchValue,
        setPage,
        pagedData,
        handleReload,
        defaultTotalPages,
        proposalDefaultPageSize,
        handleChangePageSize,
    } = useExtensionProposal()
    const { isShowActionProposalExtension } = useModalAccess()
    const { handleViewProposalExtension } = useFilesActions()

    return (
        <div className="flex h-full min-h-0 w-full flex-col bg-[#f8fafc] rounded-xl border border-gray-200">
            <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
                <SectionHeader 
                    title='Proposal Request Extension'
                    subtitle='View and monitor the current status of submitted proposals. '
                    icon={
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6l4 2" />
                            <circle cx="12" cy="12" r="9" />
                        </svg>
                    }
                />
                <div className="mx-auto flex min-h-0 w-full flex-1 flex-col gap-2">
                    <div className="flex min-h-0 flex-1 flex-col overflow-hidden bg-white shadow-sm">
                        <div className="shrink-0 border-b border-gray-200 p-3">
                            <SearchFilterBar
                                searchType={searchType}
                                setSearchType={setSearchType}
                                searchValue={searchValue}
                                setSearchValue={setSearchValue}
                                options={normalizedOptions}
                            />
                        </div>
                        {getExtensionProposalRequest?.pagination && (
                            <div className="shrink-0 border-b border-gray-200 bg-gray-50/60 p-3">
                                <Pagination
                                    setPage={setPage}
                                    handleReload={handleReload}
                                    pagination={getExtensionProposalRequest.pagination}
                                    defaultTotalPages={defaultTotalPages}
                                    setDefaultTotalPages={handleChangePageSize}
                                    totalPagesOptions={proposalDefaultPageSize}
                                />
                            </div>
                        )}
                        <div className="min-h-0 flex-1 overflow-auto">
                            <table className="min-w-max w-full border-collapse">
                                <ProposalTHead headers={[
                                    proposalHeaderData.proposalStatus.label,
                                    proposalHeaderData.groupName.label,
                                    proposalHeaderData.email.label,
                                    proposalHeaderData.proposalType.label,
                                    proposalHeaderData.product.label,
                                    proposalHeaderData.preparedBy.label,
                                ]} />
                                <ProposalExtensionTBody
                                    typeOfIcon="update"
                                    isLoadingGetProposal={loading}
                                    isErrorGetProposal={isErrorGetExtensionProposalRequest}
                                    errorMessage={errorMessage}
                                    getProposal={pagedData}
                                    handleEdit={handleViewProposalExtension}
                                />
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            {isShowActionProposalExtension && ( <ProposalExtensionActionModal/> )}
        </div>
    )
}
